'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  notification: {
    meta_title: 'Caligram - Notifications',
    title: 'Notifications',
    empty: 'No notification. Everything is under control',
    nav: {
      new: 'New',
      archived: 'Archives'
    },
    activity: {
      request: {
        message: '<b>%{sourceName}</b> wants to publish a new event in %{destinationName}.',
        action: {
          title: 'This notification requires an action.',
          message: 'Do you want to archive it anyway?'
        },
        event: {
          show: 'See the complete page',
          more_themes: '+%{smart_count} theme |||| +%{smart_count} themes',
          more_tags: 'et %{smart_count} another theme |||| and %{smart_count} other themes',
          to: 'to'
        }
      },
      declined: {
        message: 'Your event <b>%{sourceName}</b> was declined in %{destinationName}.',
        entry: {
          item: {
            message: 'Message from %{name}'
          }
        }
      },
      published: {
        message: 'Your event <b>%{sourceName}</b> was published in %{destinationName}.'
      },
      button: {
        reject: 'REJECT',
        publish: 'PUBLISH'
      }
    },
    request_modal: {
      title: 'Reject: %{title}',
      input_placeholder: 'Reason to reject this event',
      submit: 'Submit',
      submit_empty: 'Submit without a message'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/notification.js
// module id = 2284
// module chunks = 0